var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstractC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15L10 20L15 25",
    stroke: "#9d00ff",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15L40 20L35 25",
    stroke: "#9d00ff",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15H22C20.7909 15 20 15.7909 20 17V20",
    stroke: "#00f3ff",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V23C20 24.2091 20.7909 25 22 25H30",
    stroke: "#00f3ff",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 19,
    width: 4,
    height: 2,
    fill: "#00f3ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractC);
export default __webpack_public_path__ + "static/media/abstract-c.292a76ccd808491ebc53c8d95c9c8dcf.svg";
export { ForwardRef as ReactComponent };